import sortBy from "lodash/sortBy";

export const getActiveProjectsForClients = (clients = [], selectedClientId = null) => {
  const projectMap = new Map();

  clients.forEach(client => {
    if (selectedClientId && client.id !== selectedClientId) {
      return;
    }

    client.projects.forEach(project => {
      if (!project.active) return;

      projectMap.set(project.id, {
        ...project,
        client: {
          id: client.id,
          name: client.name,
        },
      });
    });
  });

  return sortBy(Array.from(projectMap.values()), project => project.name?.toLowerCase() || "");
};
